export enum SwPartNumberState {
  Dev = 'Dev',
  Snapshot = 'Snapshot',
  Released = 'Released',
}
